import { DownloadOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import { isEmpty } from 'lodash';
import { isDownloadDisabled } from 'modules/utilities/utility';
import moment from 'moment';
import React from 'react';

const DownloadPendingInvoice = ({ data, extraData, type }) => {
	const exportCSV = () => {
		try {
			let csvRow = [];
			let rowName = [
				[
					encodeURIComponent('Order Id'),
					encodeURIComponent('Order Status'),
					encodeURIComponent('Order Date'),
				],
			];

			for (let item = 0; item < data.length; item++) {
				rowName.push([
					encodeURIComponent(data[item].order_display_id),
					encodeURIComponent(data[item].status),
					encodeURIComponent(moment(data[item].createdAt).format('DD/MM/YYYY')),
				]);
			}

			for (let newitem = 0; newitem < rowName.length; newitem++) {
				csvRow.push(rowName[newitem].join(','));
			}

			let csvString = csvRow.join('%0A');
			let anchorTag = document.createElement('a');
			anchorTag.href = 'data:attachment/csv,' + csvString;
			anchorTag.target = '_Blank';
			anchorTag.download = `pending-invoice.csv`;
			document.body.appendChild(anchorTag);
			anchorTag.click();
		} catch (error) {
			message.error('download error');
		}
	};

	return (
		<Button
			type="primary"
			icon={<DownloadOutlined />}
			onClick={exportCSV}
			disabled={isDownloadDisabled || isEmpty(data)}>
			Download Orders
		</Button>
	);
};

export default DownloadPendingInvoice;
